'use strict';

/**
 *
 * Easing Functions - inspired from http://gizma.com/easing/
 *
 * @param {number} elapsedTime
 * @param {number} currentPosition
 * @param {number} difference
 * @param {number} duration
 * @return {number} position
 *
 */

window.easingTimingFunctions = {
  'linear': (elapsedTime, currentPosition, difference, duration) => {
    return difference * elapsedTime / duration + currentPosition;
  },
  'ease-in-quad': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    return difference * elapsedTime * elapsedTime + currentPosition;
  },
  'ease-out-quad': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    return - difference * elapsedTime * (elapsedTime - 2) + currentPosition;
  },
  'ease-in-out-quad': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration / 2;
    if (elapsedTime < 1) return difference / 2 * elapsedTime * elapsedTime + currentPosition;
    elapsedTime--;
    return - difference / 2 * (elapsedTime * (elapsedTime - 2) - 1) + currentPosition;
  },
  'ease-in-cubic': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    return difference * elapsedTime * elapsedTime * elapsedTime + currentPosition;
  },
  'ease-out-cubic': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    elapsedTime--;
    return difference * (elapsedTime * elapsedTime * elapsedTime + 1) + currentPosition;
  },
  'ease-in-out-cubic': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration / 2;
    if (elapsedTime < 1) return difference / 2 * elapsedTime * elapsedTime * elapsedTime + currentPosition;
    elapsedTime -= 2;
    return difference / 2 * (elapsedTime * elapsedTime * elapsedTime + 2) + currentPosition;
  },
  'ease-in-quart': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    return difference * elapsedTime * elapsedTime * elapsedTime * elapsedTime + currentPosition;
  },
  'ease-out-quart': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    elapsedTime--;
    return - difference * (elapsedTime * elapsedTime * elapsedTime * elapsedTime - 1) + currentPosition;
  },
  'ease-in-out-quart': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration / 2;
    if (elapsedTime < 1) return difference / 2 * elapsedTime * elapsedTime * elapsedTime * elapsedTime + currentPosition;
    elapsedTime -= 2;
    return - difference / 2 * (elapsedTime * elapsedTime * elapsedTime * elapsedTime - 2) + currentPosition;
  },
  'ease-in-quint': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    return difference * elapsedTime * elapsedTime * elapsedTime * elapsedTime * elapsedTime + currentPosition;
  },
  'ease-out-quint': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    elapsedTime--;
    return difference * (elapsedTime * elapsedTime * elapsedTime * elapsedTime * elapsedTime + 1) + currentPosition;
  },
  'ease-in-out-quint': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration / 2;
    if (elapsedTime < 1) return difference / 2 * elapsedTime * elapsedTime * elapsedTime * elapsedTime * elapsedTime + currentPosition;
    elapsedTime -= 2;
    return difference / 2 * (elapsedTime * elapsedTime * elapsedTime * elapsedTime * elapsedTime + 2) + currentPosition;
  },
  'ease-in-sine': (elapsedTime, currentPosition, difference, duration) => {
    return - difference * Math.cos(elapsedTime / duration * (Math.PI / 2)) + difference + currentPosition;
  },
  'ease-out-sine': (elapsedTime, currentPosition, difference, duration) => {
    return difference * Math.sin(elapsedTime / duration * (Math.PI / 2)) + currentPosition;
  },
  'ease-in-out-sine': (elapsedTime, currentPosition, difference, duration) => {
    return - difference / 2 * (Math.cos(Math.PI * elapsedTime / duration) - 1) + currentPosition;
  },
  'ease-in-expo': (elapsedTime, currentPosition, difference, duration) => {
    return difference * Math.pow(2, 10 * (elapsedTime / duration - 1)) + currentPosition;
  },
  'ease-out-expo': (elapsedTime, currentPosition, difference, duration) => {
    return difference * (- Math.pow(2, -10 * elapsedTime / duration) + 1) + currentPosition;
  },
  'ease-in-out-expo': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration / 2;
    if (elapsedTime < 1) return difference / 2 * Math.pow(2, 10 * (elapsedTime - 1)) + currentPosition;
    elapsedTime--;
    return difference / 2 * (- Math.pow(2, -10 * elapsedTime) + 2) + currentPosition;
  },
  'ease-in-circ': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    return - difference * (Math.sqrt(1 - elapsedTime * elapsedTime) - 1) + currentPosition;
  },
  'ease-out-circ': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration;
    elapsedTime--;
    return difference * Math.sqrt(1 - elapsedTime * elapsedTime) + currentPosition;
  },
  'ease-in-out-circ': (elapsedTime, currentPosition, difference, duration) => {
    elapsedTime /= duration / 2;
    if (elapsedTime < 1) return - difference / 2 * (Math.sqrt(1 - elapsedTime * elapsedTime) - 1) + currentPosition;
    elapsedTime -= 2;
    return difference / 2 * (Math.sqrt(1 - elapsedTime * elapsedTime) + 1) + currentPosition;
  },
};


/**
 *
 * slideUp
 * @param {object} $target
 * @param {function} callback
 * @param {number} duration
 *
 */

function slideUp($target, callback = function() {}, duration = 200, easing = 'ease-out-quint') {
  const targetHeight = $target.offsetHeight;
  const targetPaddingTop = parseInt(getComputedStyle($target).getPropertyValue('padding-top'));
  const targetPaddingBottom = parseInt(getComputedStyle($target).getPropertyValue('padding-bottom'));
  $target.style.display = 'block';
  $target.style.overflow = 'hidden';
  $target.style.height = targetHeight + 'px';
  $target.style.paddingTop = targetPaddingTop + 'px';
  $target.style.paddingBottom = targetPaddingBottom + 'px';
  $target.style.visibility = '';
  const startTime = performance.now();
  const render = () => {
    const elapsedTime = performance.now() - startTime;
    if (elapsedTime < duration) {
      $target.style.height = Math.floor(targetHeight - window.easingTimingFunctions[ easing ](elapsedTime, 0, targetHeight, duration)) + 'px';
      $target.style.paddingTop = Math.floor(targetPaddingTop - window.easingTimingFunctions[ easing ](elapsedTime, 0, targetPaddingTop, duration)) + 'px';
      $target.style.paddingBottom = Math.floor(targetPaddingBottom - window.easingTimingFunctions[ easing ](elapsedTime, 0, targetPaddingBottom, duration)) + 'px';
      requestAnimationFrame(render);
    } else {
      $target.style.height = '0px';
      $target.style.paddingTop = '0px';
      $target.style.paddingBottom = '0px';
      $target.style.display = 'none';
      $target.style.height = '';
      $target.style.paddingTop = '';
      $target.style.paddingBottom = '';
      $target.style.overflow = '';
      cancelAnimationFrame(render);
      // $target.setAttribute( 'aria-hidden', 'true' );
      const isShow = false;
      callback( isShow );
    }
  };
  render();
}


/**
 *
 * slideDown
 * @param {object} $target
 * @param {function} callback
 * @param {number} duration
 *
 */

function slideDown($target, callback = function() {}, duration = 200, easing = 'ease-out-quint') {
  $target.style.height = '';
  $target.style.overflow = 'hidden';
  $target.style.visibility = 'hidden';
  $target.style.display = 'block';
  const targetHeight = $target.offsetHeight;
  const targetPaddingTop = parseInt(getComputedStyle($target).getPropertyValue('padding-top'));
  const targetPaddingBottom = parseInt(getComputedStyle($target).getPropertyValue('padding-bottom'));
  $target.style.overflow = 'hidden';
  $target.style.height = '0px';
  $target.style.paddingTop = '0';
  $target.style.paddingBottom = '0';
  $target.style.visibility = '';
  const startTime = performance.now();
  const render = () => {
    const elapsedTime = performance.now() - startTime;
    if (elapsedTime < duration) {
      $target.style.height = Math.floor(window.easingTimingFunctions[ easing ](elapsedTime, 0, targetHeight, duration)) + 'px';
      $target.style.paddingTop = Math.floor(window.easingTimingFunctions[ easing ](elapsedTime, 0, targetPaddingTop, duration)) + 'px';
      $target.style.paddingBottom = Math.floor(window.easingTimingFunctions[ easing ](elapsedTime, 0, targetPaddingBottom, duration)) + 'px';
      requestAnimationFrame(render);
    } else {
      $target.style.height = targetHeight + 'px';
      $target.style.paddingTop = targetPaddingTop + 'px';
      $target.style.paddingBottom = targetPaddingBottom + 'px';
      $target.style.height = '';
      $target.style.paddingTop = '';
      $target.style.paddingBottom = '';
      $target.style.overflow = '';
      cancelAnimationFrame(render);
      // $target.setAttribute( 'aria-hidden', 'false' );
      const isShow = true;
      callback( isShow );
    }
  };
  render();
}


/**
 *
 * slideToggle
 * @param {object} $target
 * @param {function} beforeCallback
 * @param {function} afterCallback
 * @param {number} duration
 *
 */

function slideToggle($target, beforeCallback = function() {}, afterCallback = function() {}, duration = 200, easing = 'ease-out-quint') {
  if (getComputedStyle($target).getPropertyValue('display') === 'none') {
    const isShow = true;
    beforeCallback(isShow);
    slideDown($target, afterCallback, duration, easing);
  } else {
    const isShow = false;
    beforeCallback(isShow);
    slideUp($target, afterCallback, duration, easing);
  }
}


/**
 *
 * Search Form
 *
 */

document.addEventListener( 'DOMContentLoaded', () => {
  const searchForms = document.querySelectorAll( '.mt-search-form' );
  [].forEach.call( searchForms, $searchForm => {
    const $heading = $searchForm.querySelector( '.mt-search-form__toggle' );
    if ( $heading ) {
      $heading.addEventListener( 'click', e => {
        e.preventDefault();
        const $searchFormContent = $searchForm.querySelector( '.mt-search-form__content' );
        slideToggle( $searchFormContent, isShow => {
          const $label = $heading.querySelector( '.mt-search-form__toggle-label' );
          if ( isShow ) {
            $heading.setAttribute( 'aria-expanded', 'true' );
            if ( $label ) {
              $label.innerText = $heading.getAttribute( 'data-toggle-opened-label' );
            }
          } else {
            $heading.setAttribute( 'aria-expanded', 'false' );
            if ( $label ) {
              $label.innerText = $heading.getAttribute( 'data-toggle-closed-label' );
            }
          }
        }, isShow => {
          if ( isShow ) {
            $searchFormContent.setAttribute( 'aria-hidden', 'false' );
          } else {
            $searchFormContent.setAttribute( 'aria-hidden', 'true' );
          }
        }, MT_CSS[ 'animation_duration' ], MT_CSS[ 'animation_timing_function' ] );
      } );
    }
    $searchForm.addEventListener( 'submit', e => {
      e.preventDefault();
      const url = $searchForm.getAttribute( 'action' );
      const formData = new FormData( e.target );
      const fields = $searchForm.querySelectorAll( '.mt-search-form__cell' );
      const params = {};
      [].forEach.call( fields, $field => {
        const name = $field.getAttribute( 'data-name' );
        const condition = $field.getAttribute( 'data-condition' );
        if ( ! condition ) {
          const value = formData.get( name );
          if ( value ) {
            params[ name ] = value;
          }
        } else {
          const values = formData.getAll( name );
          if ( values.length ) {
            params[ name.replace( '[]', '' ) ] = values.join( condition );
          }
        }
      } );
      const paramsString =  new URLSearchParams( params ).toString();
      location.href = url + '?' + paramsString;
    } );
  } );
} );


/**
 *
 * Menu Toggle
 *
 */

document.addEventListener( 'DOMContentLoaded', () => {
  const menuToggle = document.querySelectorAll( '.mt-menu__sub-toggle' );
  [].forEach.call( menuToggle, $menuToggle => {
    $menuToggle.addEventListener( 'click', e => {
      e.preventDefault();
      const $parent = $menuToggle.parentElement;
      const $menuSub = $parent.querySelector( '.mt-menu__sub' );
      if ( $menuSub ) {
        slideToggle( $menuSub, isShow => {
          if ( isShow ) {
            $menuToggle.setAttribute( 'aria-expanded', 'true' );
            $menuToggle.setAttribute( 'aria-label', $menuToggle.getAttribute( 'data-toggle-opened-label' ) );
          } else {
            $menuToggle.setAttribute( 'aria-expanded', 'false' );
            $menuToggle.setAttribute( 'aria-label', $menuToggle.getAttribute( 'data-toggle-closed-label' ) );
          }
        }, isShow => {
          if ( isShow ) {
            $menuSub.setAttribute( 'aria-hidden', 'false' );
          } else {
            $menuSub.setAttribute( 'aria-hidden', 'true' );
          }
        }, MT_CSS[ 'animation_duration' ], MT_CSS[ 'animation_timing_function' ] );
      }
    } );
  } );
} );


/**
 *
 * Menu Tooltips
 *
 */

document.addEventListener( 'DOMContentLoaded', () => {
  const tooltips = document.querySelectorAll('.mt-menu--tooltip');
  if ( tooltips.length ) {
    const isOverTooltipsBreakPoint = () => {
      return parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--mt-is-over-break-point' ) );
    };

    [].forEach.call( tooltips, $tooltip => {
      const menuSubList = $tooltip.querySelectorAll( '.mt-menu__sub' );
      const menuToggleList = $tooltip.querySelectorAll( '.mt-menu__sub-toggle' );
      const menuList = [].map.call( menuToggleList, $menuToggle => $menuToggle.parentElement );
      const memo = menuList.map( $menu => {
        return {
          el: $menu,
          sub: $menu.querySelector( '.mt-menu__sub' ),
          links: $menu.querySelectorAll( 'a' ),
        }
      } );

      // ツールチップの属性のリセット
      const resetTooltipsAttributes = () => {
        [].forEach.call( menuSubList, $menuSub => {
          $menuSub.setAttribute( 'aria-hidden', 'true' );
          // $menuSub.style.visibility = 'hidden';
        } );
        [].forEach.call( menuList, $menu => {
          $menu.classList.remove( 'is-hover' );
          $menu.classList.remove( 'is-focus' );
        } );
      };

      // リサイズイベントの設定
      let useTooltip = false;
      const resizeHandler = () => {
        if ( isOverTooltipsBreakPoint() ) {
          useTooltip = true;
          [].forEach.call( menuSubList, $menuSub => {
            $menuSub.setAttribute( 'aria-hidden', 'true' );
            // $menuSub.style.display = 'block';
            // $menuSub.style.position = 'absolute';
            // $menuSub.style.visibility = 'hidden';
          } );
          [].forEach.call( menuToggleList, $menuToggle => {
            $menuToggle.setAttribute( 'aria-expanded', 'false' );
            $menuToggle.setAttribute( 'aria-label', $menuToggle.getAttribute( 'data-toggle-closed-label' ) );
            // $menuToggle.style.display = 'none';
          } );
          [].forEach.call( menuList, $menu => {
            $menu.classList.remove( 'is-hover' );
            $menu.classList.remove( 'is-focus' );
          } );
        } else {
          useTooltip = false;
          [].forEach.call( menuSubList, $menuSub => {
            $menuSub.setAttribute( 'aria-hidden', 'true' );
            // $menuSub.style.display = 'none';
            // $menuSub.style.position = '';
            // $menuSub.style.visibility = '';
          } );
          [].forEach.call( menuToggleList, $menuToggle => {
            $menuToggle.setAttribute( 'aria-expanded', 'false' );
            $menuToggle.setAttribute( 'aria-label', $menuToggle.getAttribute( 'data-toggle-closed-label' ) );
            // $menuToggle.style.display = '';
          } );
          [].forEach.call( menuList, $menu => {
            $menu.classList.remove( 'is-hover' );
            $menu.classList.remove( 'is-focus' );
          } );
        }
      };
      resizeHandler();
      window.addEventListener('resize', resizeHandler );

      // イベントハンドラーの設定
      memo.forEach( m => {
        m.el.addEventListener( 'mouseover', () => {
          if ( useTooltip ) {
            m.el.classList.add( 'is-hover' );
            m.sub.setAttribute( 'aria-hidden', 'false' );
            // m.sub.style.visibility = 'visible';
          }
        } );
        m.el.addEventListener( 'mouseout', () => {
          if ( useTooltip ) {
            m.el.classList.remove( 'is-hover' );
            m.sub.setAttribute( 'aria-hidden', 'true' );
            // m.sub.style.visibility = 'hidden';
          }
        } );
        [].forEach.call( m.links, $link => {
          $link.addEventListener( 'focus', () => {
            if ( useTooltip ) {
              resetTooltipsAttributes();
              m.el.classList.add('is-focus');
              m.sub.setAttribute( 'aria-hidden', 'false' );
              // m.sub.style.visibility = 'visible';
            }
          } );
          $link.addEventListener( 'blur', e => {
            if ( useTooltip && e.relatedTarget ) {
              let $target = e.relatedTarget.parentNode;
              while ( $target !== m.el ) {
                $target = $target.parentNode;
                if ( $target === document ) {
                  resetTooltipsAttributes();
                  break;
                }
              }
            }
          } );
        } );
      });
    } );
  }
});


/**
 *
 * Terms Navigation Toggle
 *
 */

document.addEventListener( 'DOMContentLoaded', () => {
  const menuToggle = document.querySelectorAll( '.mt-terms-navigation__sub-toggle' );
  [].forEach.call( menuToggle, $menuToggle => {
    $menuToggle.addEventListener( 'click', e => {
      e.preventDefault();
      const $parent = $menuToggle.parentElement;
      const $menuSub = $parent.querySelector( '.mt-terms-navigation__sub' );
      if ( $menuSub ) {
        slideToggle( $menuSub, isShow => {
          if ( isShow ) {
            $menuToggle.setAttribute( 'aria-expanded', 'true' );
            $menuToggle.setAttribute( 'aria-label', $menuToggle.getAttribute( 'data-toggle-opened-label' ) );
          } else {
            $menuToggle.setAttribute( 'aria-expanded', 'false' );
            $menuToggle.setAttribute( 'aria-label', $menuToggle.getAttribute( 'data-toggle-closed-label' ) );
          }
        }, isShow => {
          if ( isShow ) {
            $menuSub.setAttribute( 'aria-hidden', 'false' );
          } else {
            $menuSub.setAttribute( 'aria-hidden', 'true' );
          }
        }, MT_CSS[ 'animation_duration' ], MT_CSS[ 'animation_timing_function' ] );
      }
    } );
  } );
} );

/**
 *
 * Global Menu
 *
 */

document.addEventListener( 'DOMContentLoaded', () => {
  const $menu = document.querySelector( '.mt-global-menu' );
  if ( $menu ) {
    const isOverTooltipsBreakPoint = () => {
      return parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--mt-is-over-break-point' ) );
    };
    const $body = document.querySelector( 'body' );
    const $container = document.querySelector( '.mt-global-menu-container' );
    const $toggle = document.querySelector( '.mt-global-menu-toggle' );
    const globalMenuOpenedClass = 'is-global-menu-open';
    const interactiveElementsSelector = 'a, button';

    const _changeAccessibilityAttributes = () => {
      // aria-hiddenをメニュー以外の要素に付与するため、対象の要素を抽出する
      let $target = $menu;
      let $menuParent = $menu.parentElement;
      let hiddenElements = [];
      while ( $menuParent.tagName !== 'HTML' ) {
        const otherThanMenu = $menuParent.querySelectorAll( ':scope > :not(style):not(script)' );
        [].forEach.call( otherThanMenu, $otherThanMenu => {
          if ( $otherThanMenu !== $target ) {
            hiddenElements.push( $otherThanMenu );
          }
        } );
        $target = $menuParent;
        $menuParent = $menuParent.parentElement;
      }
      // アクセシビリティ関連の属性を変更する
      if ( useGlobalMenu ) {
        $container.style.setProperty( '--mt-header-height', $menu.getBoundingClientRect().bottom + 'px' );
        if ( $body.classList.contains( globalMenuOpenedClass ) ) {
          $toggle.setAttribute( 'aria-expanded', 'true' );
          if ( $toggle.getAttribute( 'data-toggle-opened-label' ) ) {
            $toggle.setAttribute( 'aria-label', $toggle.getAttribute( 'data-toggle-opened-label' ) );
          }
          $container.setAttribute( 'aria-hidden', 'false' );
          hiddenElements.map( $hiddenElement => $hiddenElement.setAttribute( 'aria-hidden', 'true' ) );
          $body.style.overflow = 'hidden';
        } else {
          $toggle.setAttribute( 'aria-expanded', 'false' );
          if ( $toggle.getAttribute( 'data-toggle-closed-label' ) ) {
            $toggle.setAttribute( 'aria-label', $toggle.getAttribute( 'data-toggle-closed-label' ) );
          }
          $container.setAttribute( 'aria-hidden', 'true' );
          hiddenElements.map( $hiddenElement => $hiddenElement.removeAttribute( 'aria-hidden' ) );
          $body.style.overflow = '';
        }
      } else {
        $container.style.removeProperty( '--mt-header-height' );
        $toggle.removeAttribute( 'aria-expanded' );
        $toggle.removeAttribute( 'aria-label' );
        $container.removeAttribute( 'aria-hidden' );
        hiddenElements.map( $hiddenElement => $hiddenElement.removeAttribute( 'aria-hidden' ) );
        $body.style.overflow = '';
      }
    };

    let useGlobalMenu = false;
    const resizeHandler = () => {
      if ( ! isOverTooltipsBreakPoint() ) {
        useGlobalMenu = true;
      } else {
        useGlobalMenu = false;
      }
      _changeAccessibilityAttributes();
    };
    window.addEventListener( 'resize', resizeHandler );
    resizeHandler();

    const close = () => {
      $body.classList.remove( globalMenuOpenedClass );
      _changeAccessibilityAttributes();
      document.removeEventListener( 'keydown', keyEventHandler );
      document.removeEventListener( 'touchmove', touchmoveHandler );
      $container.removeEventListener( 'scroll', containerTouchmoveHandler );
      $toggle.focus();
    };

    const open = () => {
      $body.classList.add( globalMenuOpenedClass );
      _changeAccessibilityAttributes();
      document.addEventListener( 'keydown', keyEventHandler, { capture: true } );
      document.addEventListener( 'touchmove', touchmoveHandler, { passive: false } );
      $container.addEventListener( 'scroll', containerTouchmoveHandler );
    };

    const clickHandler = e => {
      e.stopPropagation();
      e.preventDefault();
      if ( useGlobalMenu ) {
        if ( $body.classList.contains( globalMenuOpenedClass ) ) {
          close();
        } else {
          open();
        }
      }
    };
    $toggle.addEventListener( 'click', clickHandler );

    const keyEventHandler = e => {
      if ( useGlobalMenu && $body.classList.contains( globalMenuOpenedClass ) ) {
        const $target = e.target;
        const code = e.code;
        if ( code === 'Escape' ) {
          e.stopImmediatePropagation();
          e.preventDefault();
          close();
        } else if ( code === 'Tab' ) {
          e.stopImmediatePropagation();
          e.preventDefault();
          const globalMenuInteractiveElements = Array.from( $menu.querySelectorAll( interactiveElementsSelector ) );
          const focusIndex = globalMenuInteractiveElements.findIndex( el => el === document.activeElement );
          let index = 0;
          if ( focusIndex !== -1 ) {
            index = e.shiftKey ? focusIndex - 1 : focusIndex + 1;
          }
          const maxIndex = globalMenuInteractiveElements.length - 1;
          if ( index > maxIndex ) {
            index = 0;
          } else if ( index < 0 ) {
            index = maxIndex;
          }
          globalMenuInteractiveElements[ index ].focus();
          while ( globalMenuInteractiveElements[ index ] !== document.activeElement ) {
            if ( e.shiftKey ) {
              index--;
            } else {
              index++;
            }
            if ( index > maxIndex || index < 0 ) {
              break;
            } else {
              globalMenuInteractiveElements[ index ].focus();
            }
          }
        }
      }
    };

    const touchmoveHandler = e => {
      if ( useGlobalMenu && $body.classList.contains( globalMenuOpenedClass ) ) {
        if ( ! e.target.closest( '.mt-global-menu-container' ) || ( $container.clientHeight === $container.scrollHeight ) ) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    };

    // メニューを上下どちらかに最大までスクロールすると背景がスクロールされるバグの対策
    const containerTouchmoveHandler = e => {
      if ( useGlobalMenu && $body.classList.contains( globalMenuOpenedClass ) ) {
        if ( $container.scrollTop + $container.clientHeight === $container.scrollHeight ) {
          $container.scrollTop = $container.scrollTop - 1;
        }
        if ( $container.scrollTop === 0 ) {
          $container.scrollTop = 1;
        }
      }
    };
  }
} );


/**
 *
 * FAQ
 *
 */

document.addEventListener( 'DOMContentLoaded', () => {
  const faqList = document.querySelectorAll( '.mt-faq' );
  faqList.forEach( $faq => {
    const $question = $faq.querySelector( '.mt-faq__question' );
    const $answer = $faq.querySelector( '.mt-faq__answer' );
    $question.addEventListener( 'click', e => {
      e.stopPropagation();
      e.preventDefault();
      if ( $faq.getAttribute( 'open' ) !== null ) {
        $faq.classList.add( 'is-closing' );
        slideUp( $answer, () => {
          $faq.classList.remove( 'is-closing' );
          $faq.removeAttribute( 'open' );
          $answer.style.display = '';
        }, MT_CSS[ 'animation_duration' ], MT_CSS[ 'animation_timing_function' ] );
      } else {
        $faq.classList.add( 'is-opening' );
        $faq.setAttribute( 'open', 'open' )
        slideDown( $answer, () => {
          $faq.classList.remove( 'is-opening' );
        }, MT_CSS[ 'animation_duration' ], MT_CSS[ 'animation_timing_function' ] );
      }
    } );
  } );
} );


/**
 *
 * TOC
 *
 */

 document.addEventListener( 'DOMContentLoaded', () => {
  const tocList = document.querySelectorAll( '.mt-toc' );
  tocList.forEach( $toc => {
    const $head = $toc.querySelector( '.mt-toc__head' );
    const $body = $toc.querySelector( '.mt-toc__body' );
    $head.addEventListener( 'click', e => {
      e.stopPropagation();
      e.preventDefault();
      if ( $toc.getAttribute( 'open' ) !== null ) {
        $toc.classList.add( 'is-closing' );
        slideUp( $body, () => {
          $toc.classList.remove( 'is-closing' );
          $toc.removeAttribute( 'open' )
        }, MT_CSS[ 'animation_duration' ], MT_CSS[ 'animation_timing_function' ] );
      } else {
        $toc.classList.add( 'is-opening' );
        $toc.setAttribute( 'open', 'open' )
        slideDown( $body, () => {
          $toc.classList.remove( 'is-opening' );
        }, MT_CSS[ 'animation_duration' ], MT_CSS[ 'animation_timing_function' ] );
      }
    } );
  } );
} );
